// src/components/CreateSpace/Step2/step2.constants.js

export const EXTRA_PICTURES_OPTION_ID = "77d40eb2-83d6-4d37-b915-59a793ec942e";
export const TARGET_IMAGE_SIZE_MB = 0.15;
export const MAX_TOTAL_PAYLOAD_MB = 0.95;
export const TARGET_IMAGE_DIMENSION = 800;

export const SERVICE_RENTAL_TYPES = [
  { value: "hour", label: "À l'heure" },
  { value: "halfDay", label: "À la demi-journée" },
  { value: "day", label: "À la journée" },
  { value: "included", label: "Inclus" },
  
];

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg', 
  'image/jpg', 
  'image/png', 
  'text/plain'
];

export const PREDEFINED_SEMINARS = [
  { id: 1, type: "halfday", number: "1", price: null, offer: null },
  { id: 2, type: "halfday", number: "2", price: null, offer: null },
  { id: 3, type: "day", number: "1", price: null, offer: null },
  { id: 4, type: "day", number: "2", price: null, offer: null },
  { id: 5, type: "residential", number: "1", price: null, offer: null },
  { id: 6, type: "residential", number: "2", price: null, offer: null },
];

export const IMAGE_FIELDS = {
  COVER: 1,
  REGULAR: [2, 3],
  EXTRA: [4, 5, 6],
  ALL: [1, 2, 3, 4, 5, 6]
};

export const PLACE_USAGE_TYPES = {
  PRIVATE_OFFICE: "private_office",
  SHARED_OFFICE: "shared_office",
  COWORKING: "coworking",
  SEMINAR: "seminar",
  TEAMBUILDING: "teambuilding",
  MEETING_ROOM: "meeting_room",
  CONFERENCE_ROOM: "conference_room"
};

export const SERVICE_TYPES = {
  FREE: "free",
  RESERVATION: "reservation",
  ONSITE: "onsite",
  CUSTOM: "custom"
};